import Wix from '../services/wix-sdk-polyfill';
import { loginMember } from './login-member';
import { debug } from '../services/debug';

export const fetchCurrentMember = () => dispatch => {
  return new Promise(resolve => {
    Wix.currentMember(member => {
      if (member) {
        dispatch(loginMember(member.data || member)) // OR is needed because callback is called with different data
          .then(resolve)
          .catch(error => debug.error('fetchCurrentMember', error));
        return;
      }
      resolve();
    });
    setTimeout(resolve, 300);
  });
};
